import { queryString } from '@/util/Axios'

export const ApiBookings = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const check = async (id, module = 'accommodations', payload) => {
    const result = await axios.post(`/api/bookings/check/${module}/${id}`, payload)
    return result.data
  }

  const reservation = async (bookingCode, payload) => {
    const result = await axios.post(`/api/bookings/${bookingCode}/reservation`, payload)
    return result.data
  }

  const migrate = async (aid) => {
    const result = await axios.post(`/api/bookings/migrate/${aid}`)
    return result.data
  }

  const createDocument = async (bookingCode, documentId) => {
    const result = await axios.get(`/api/bookings/${bookingCode}/documents/${documentId}`)
    return result.data
  }

  const documents = async (bookingCode) => {
    const result = await axios.get(`/api/bookings/${bookingCode}/documents`)
    return result.data
  }

  const convert = async (bookingCode, status) => {
    const result = await axios.post(`/api/bookings/${bookingCode}/convert/${status}`)
    return result.data
  }

  const obuAction = async (bookingCode, status) => {
    console.log('***', status)
    const result = await axios.post(`/api/bookings/${bookingCode}/${status}`)
    return result.data
  }

  const find = async (id, bookingCode, module = 'accommodations') => {
    const result = await axios.get(`/api/bookings/${module}/${id}/${bookingCode}/details`)
    return result.data
  }

  const update = async (id, bookingCode, payload, module = 'accommodations') => {
    const result = await axios.patch(`/api/bookings/${module}/${id}/${bookingCode}/update`, payload)
    return result.data
  }

  const addResources = async (id, bookingCode, payload, module = 'accommodations') => {
    const result = await axios.patch(`/api/bookings/${module}/${id}/${bookingCode}/add-resources`, payload)
    return result.data
  }

  const changePeriod = async (id, bookingCode, payload, module = 'accommodations') => {
    const result = await axios.patch(`/api/bookings/${module}/${id}/${bookingCode}/change-period`, payload)
    return result.data
  }

  const updateOccupation = async (id, bookingCode, payload, module = 'accommodations') => {
    const result = await axios.patch(`/api/bookings/${module}/${id}/${bookingCode}/update-occupation`, payload)
    return result.data
  }

  const index = async (id, type, year, month, query, module = 'accommodations', params) => {
    const result = await axios.get(`/api/bookings/${module}/${id}/${year}/${month}/${type}?${queryString.stringify(params)}`)
    return result.data
  }

  const recalculate = async (bookingCode) => {
    const result = await axios.post(`/api/bookings/${bookingCode}/recalculate`)
    return result.data
  }

  const pdfUrl = async (bookingCode, view = 'calc') => {
    const result = await axios.get(`/api/bookings/${bookingCode}/pdf/url/${view}`)
    return result.data
  }

  const remove = async (bookingCode) => {
    const result = await axios.delete(`/api/bookings/${bookingCode}/remove`)
    return result.data
  }

  const cancel = async (bookingCode, status) => {
    const result = await axios.delete(`/api/bookings/${bookingCode}/cancel/${status}`)
    return result.data
  }

  const complete = async (bookingCode, payload) => {
    const result = await axios.post(`/api/bookings/${bookingCode}/complete`, payload)
    return result.data
  }

  const calculateCart = async (bookingCode, payload) => {
    const result = await axios.post(`/api/bookings/${bookingCode}/cart/calculate`, payload)
    return result.data
  }

  const entitiesForCalendar = async () => {
    const result = await axios.get('/api/bookings/calendar-entities')
    return result.data
  }

  return {
    bookingsCalculateCart: calculateCart,
    bookingsCancel: cancel,
    bookingsCheck: check,
    bookingsComplete: complete,
    bookingsConvert: convert,
    bookingsMigrate: migrate,
    bookingsDocuments: documents,
    bookingsDocumentsCreate: createDocument,
    bookingsFind: find,
    bookingChangePeriod: changePeriod,
    bookingsObuAction: obuAction,
    bookingAddResources: addResources,
    bookingsPdfUrl: pdfUrl,
    bookingUpdate: update,
    bookingUpdateOccupation: updateOccupation,
    bookingsReservation: reservation,
    bookingsIndex: index,
    bookingsRecalculate: recalculate,
    bookingsRemove: remove,
    bookingsEntitiesForCalendar: entitiesForCalendar
  }
}
